/** The message of a thrown value, or the fallback when it is not an Error. */
export const getErrorMessage = (error: unknown, fallback: string): string =>
  error instanceof Error ? error.message : fallback;
